import React from 'react';

const CalendarTab: React.FC = () => {
  return (
    <div style={{ padding: '32px 12px', textAlign: 'center', color: 'var(--text-color-calendar-week)' }}>
      <div style={{ fontSize: 32, marginBottom: 12 }}>📅</div>
      <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-color-calendar)' }}>Coming soon</div>
      <div style={{ fontSize: 11, marginTop: 6, lineHeight: 1.5 }}>
        Today's schedule from the Booking module will appear here
      </div>
    </div>
  );
};

export default CalendarTab;
